import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import BoxedCustomControl from '../../../../../../../components/global/BoxedCustomControl';
import { ALBUM_UPLOAD_PERMISSIONS } from '../../../../../../../constants/albums';
import Alert from '../../../../../../../components/global/Alert';
import CustomControl from '../../../../../../../components/global/CustomControl';

const propTypes = {
  values: PropTypes.shape({
    permission: PropTypes.string,
  }).isRequired,
  errors: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func,
  allowReviewToggle: PropTypes.bool,
  showErrors: PropTypes.bool,
};

const EventShutterbugPermissions = ({
  values,
  errors,
  handleChange,
  handleBlur,
  allowReviewToggle = true,
  showErrors = true,
}) => {
  const errorList = Object.values(errors);

  return (
    <Fragment>
      {showErrors && errorList.length > 0 && (
        <Alert type="danger" className="mb-3">
          <ul>
            {errorList.map(error => (
              <li key={error}>{error}</li>
            ))}
          </ul>
        </Alert>
      )}

      <div className="d-flex flex-column">
        <div className="mt-2">
          <h4 id="label-permissions" className="d-block mb-1">
            Allow others to add their photos and videos?
          </h4>

          <div className="create-step-two-column-grid create-step-two-column-grid-sm">
            <BoxedCustomControl
              label="Yes"
              type="checkbox"
              id="album-permission-anyone"
              name="permission"
              onChange={() =>
                handleChange({
                  target: {
                    name: 'permission',
                    value: ALBUM_UPLOAD_PERMISSIONS.ANYONE,
                  },
                })
              }
              checked={values.permission === ALBUM_UPLOAD_PERMISSIONS.ANYONE}
              className="mb-2 text-center"
              boxStyle="secondary"
            />

            <BoxedCustomControl
              label="No"
              type="checkbox"
              id="album-permission-invitees"
              name="permission"
              onChange={() =>
                handleChange({
                  target: {
                    name: 'permission',
                    value: ALBUM_UPLOAD_PERMISSIONS.NONE,
                  },
                })
              }
              checked={values.permission === ALBUM_UPLOAD_PERMISSIONS.NONE}
              className="mb-2 text-center"
              boxStyle="secondary"
            />
          </div>

          {values.permission === ALBUM_UPLOAD_PERMISSIONS.ANYONE &&
            allowReviewToggle && (
              <CustomControl
                id="require-review"
                type="checkbox"
                name="require_review"
                label="I want to approve photos and videos prior to being published"
                checked={values.require_review}
                onChange={handleChange}
                onBlur={handleBlur}
                className="checkbox-require-photo-approval lh-normal"
              />
            )}
        </div>
      </div>
    </Fragment>
  );
};

EventShutterbugPermissions.propTypes = propTypes;

export default EventShutterbugPermissions;
